"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ApiError_1 = require("./Error/ApiError");

var FetchError_1 = require("./Error/FetchError");

var JsonError_1 = require("./Error/JsonError");

var ExecuteMethod_1 = require("./ExecuteMethod");

var Validator_1 = require("./Validator");

var RestAdapter =
/** @class */
function () {
  function RestAdapter(config) {
    this.config = config;
    this.validator = new Validator_1.Validator();
  }

  RestAdapter.prototype.findAll = function (resourceType) {
    var uri = this.buildUri(resourceType);
    return this.configureGetPromise(uri, this.checkCollectionResult);
  };

  RestAdapter.prototype.findByIdentifier = function (resourceType, identifier) {
    this.assertValidIdentifier(identifier);
    var uri = this.buildUri(resourceType) + '/' + identifier;
    return this.configureGetPromise(uri, this.checkSingleResult);
  };
  /**
   * Send a POST request to the given Resource Type
   *
   * @param resourceType
   * @param body
   */


  RestAdapter.prototype.post = function (resourceType, body) {
    var uri = this.buildUri(resourceType);
    return this.configurePostPromise(uri, body, this.checkPostResult);
  };
  /**
   * Perform a GET or POST request to the given API path
   *
   * @param {string} requestPath
   * @param {string} method
   * @param {I} body
   * @return {Promise<R>}
   */


  RestAdapter.prototype.execute = function (requestPath, method, body) {
    if (method === void 0) {
      method = ExecuteMethod_1.ExecuteMethod.GET;
    }

    var uri = this.config.endpoint.toString() + requestPath;

    if (method === 'GET') {
      return this.configureGetPromise(uri, this.checkExecuteResult);
    } else if (method === 'POST') {
      if (arguments.length < 3) {
        throw new ReferenceError('Missing request body');
      }

      return this.configurePostPromise(uri, body, this.checkExecuteResult);
    } else {
      throw new TypeError("Method '" + method + "' is not implemented");
    }
  };

  RestAdapter.prototype.configureGetPromise = function (uri, successCallback) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return _this.sendGet(uri).then(_this.buildResponseCheck(reject)).then(function (decodedData) {
        return successCallback.call(_this, decodedData, resolve, reject);
      }).catch(function (e) {
        reject(ApiError_1.buildError(FetchError_1.FetchError, e));
      });
    });
  };

  RestAdapter.prototype.configurePostPromise = function (uri, body, successCallback) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return _this.sendPost(uri, body).then(_this.buildResponseCheck(reject)).then(function (decodedData) {
        return successCallback.call(_this, decodedData, resolve, reject);
      }).catch(function (e) {
        reject(ApiError_1.buildError(FetchError_1.FetchError, e));
      });
    });
  };

  RestAdapter.prototype.buildResponseCheck = function (reject) {
    return function (response) {
      if (response.ok) {
        // If the response is ok try to decode the JSON body
        try {
          return response.json();
        } catch (e) {
          reject(ApiError_1.buildError(JsonError_1.JsonError, e));
          return undefined;
        }
      } else {
        // If there was an error look if a JSON body is given
        return response.json().then(function (errorData) {
          reject(ApiError_1.buildError(FetchError_1.FetchError, errorData));
        }).catch(function () {
          reject(ApiError_1.buildError(FetchError_1.FetchError, response));
        });
      }
    };
  };

  RestAdapter.prototype.assertValidResourceType = function (resourceType) {
    if (typeof resourceType !== 'string') {
      throw new TypeError("Resource Type must be of type string \"" + typeof resourceType + "\" given");
    } // if (resourceType.indexOf('/') > -1) {
    //     throw new TypeError('Resource Type must not contain a slash');
    // }

  };

  RestAdapter.prototype.assertValidIdentifier = function (identifier) {
    var identifierString;

    if (typeof identifier === 'string') {
      identifierString = identifier;
    }

    if (identifier && typeof identifier.toString === 'function') {
      identifierString = identifier.toString();
    } else {
      throw new TypeError('Argument "identifier" must implement IdentifierInterface. ' + '"' + typeof identifier + '" given');
    }

    if (identifierString.indexOf('/') > -1) {
      throw new TypeError('Identifier must not contain a slash');
    }
  };

  RestAdapter.prototype.sendGet = function (uri) {
    return this.fetch(uri, this.config.requestSettings);
  };

  RestAdapter.prototype.sendPost = function (uri, body) {
    var config = this.config;
    var requestSettings = Object.assign({}, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: typeof body !== 'string' ? JSON.stringify(body) : body
    }, config.requestSettings);
    return this.fetch(uri, requestSettings);
  };

  RestAdapter.prototype.fetch = function (uri, requestSettings) {
    var fetchCallback = this.config.fetchCallback;
    var xhrPromise;

    if (fetchCallback) {
      // Use the custom fetch callback
      xhrPromise = fetchCallback(uri, requestSettings);
    } else {
      // Use the JavaScript Fetch API (https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)
      xhrPromise = fetch(uri, requestSettings);
    }

    return xhrPromise;
  };

  RestAdapter.prototype.buildUri = function (resourceType) {
    return this.config.endpoint.toString() + this.pathForResourceType(resourceType);
  };

  RestAdapter.prototype.pathForResourceType = function (resourceType) {
    this.assertValidResourceType(resourceType);
    return resourceType.replace(/_?([A-Z]+)/g, function (x, y) {
      return '_' + y.toLowerCase();
    }).replace(/\./, '-').replace(/-_/g, '-').replace(/^_/, '');
  };

  RestAdapter.prototype.checkSingleResult = function (result, resolve, reject) {
    this.validator.validateSingleResult(result, resolve, reject);
  };

  RestAdapter.prototype.checkCollectionResult = function (result, resolve, reject) {
    this.validator.validateCollectionResult(result, resolve, reject);
  };

  RestAdapter.prototype.checkExecuteResult = function (result, resolve, reject) {
    this.validator.validateSingleResult(result, resolve, reject);
  };

  RestAdapter.prototype.checkPostResult = function (result, resolve, reject) {
    this.validator.validateSingleResult(result, resolve, reject);
  };

  return RestAdapter;
}();

exports.RestAdapter = RestAdapter;